<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useNavigation } from '@/hooks/useNavigation';
import { mobileNavItems } from '@/router/navigation';

function isActive(route?: string) {
  return !!useRoute().matched.filter((item) => item.path === route).length;
}

const { availableItems } = useNavigation(mobileNavItems);
</script>

<template>
  <v-bottom-navigation height="70" grow app class="z-1">
    <v-btn
      v-for="item in availableItems"
      :key="item.name"
      :active="isActive(item.route)"
      :to="item.route"
      :color="isActive(item.route) ? 'primary' : 'contrast'"
      class="text-center relative bg-transparent shadow-none"
    >
      <v-icon :icon="item.icon" />
      <p class="mt-2">{{ $t(item.label) }}</p>
      <span
        v-if="isActive(item.route)"
        class="absolute bottom-0 left-0 right-0 h-[3px] w-full bg-af-pink"
      ></span>
    </v-btn>
  </v-bottom-navigation>
</template>

<style scoped>
:deep(.v-btn__overlay) {
  display: none;
}
</style>
